import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import Swal from "sweetalert2";

var mi_grid = {};
class Establecimientos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buscarProductos: {},
      estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
      tipoEstablecimientoCombo: Api.loadCatalogue("cat_tipo_establecimiento"),
      tipoActividadCombo: Api.loadCatalogue("cat_actividad"),
      TramiteCombo: Api.loadCatalogue("cat_accion"),
      nivelUsuario: localStorage.nivel_actual,
    };
    this.handleAnotacionMarginalEstablecimiento =
      this.handleAnotacionMarginalEstablecimiento.bind(this);
  }

  handleAnotacionMarginalEstablecimiento = (data) => {
    Api.loading(1);

    let apiFetch =
      "app/getNME?id=" +
      data.solicitud_id +
      "&establecimiento=" +
      data.razon_social;

    Api.fetch(apiFetch).then((r) => {
      Api.loading(0);
      import(`../components/notas-marginales/NMGeneral.jsx`).then((m) => {
        m.request(r, () => {
          mi_grid.go(0);
        });
      });
    });
  };

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getSolicitudesEstablecimientosUser",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio_solicitud: {
          label: "Folio Solicitud",
        },
        accion: {
          label: "Trámite",
          render: (me) => {
            if (me.data.tramite !== null) {
              me.innerHTML = me.data.accion;
            } else {
              me.innerHTML = "";
            }
          },
        },
        razon_social: {
          label: "Razón social",
          render: (me) => {
            if (me.data.razon_social === null) {
              me.innerHTML = "";
            }
          },
        },
        est_guid: {
          label: "GUID",
          render: (me) => {
            if (me.data.est_guid === null) {
              me.innerHTML = "";
            } else {
              me.innerHTML = me.data.est_guid.slice(-4);
            }
          },
        },
        tipo: {
          label: "Tipo establecimiento",
          render: (me) => {
            if (me.data.tipo) {
              me.innerHTML =
                "<span title='" +
                me.data.tipo +
                "'>" +
                me.data.tipo.substr(0, 100) +
                "...</span>";
            }
          },
        },
        actividad: {
          label: "Tipo actividad",
          render: (me) => {
            if (me.data.actividad) {
              me.innerHTML =
                "<span title='" +
                me.data.actividad +
                "'>" +
                me.data.actividad.substr(0, 100) +
                "...</span>";
            }
          },
        },
        fecha_solicitud: {
          label: "Fecha Solicitud",
          render: (me) => {
            me.innerHTML = me.data.fecha_solicitud
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        descripcion: {
          label: "Estado",
          render: (me) => {
            if(me.data.estatus_tramite_id === "9" || me.data.estatus_tramite_id === "10"){
                me.innerHTML = "En espera";
            }else if(me.data.estatus_tramite_id === "3" ){
                if(me.data.accion_id==="3005"){
                    me.innerHTML = "Atender anotación marginal";
                }else{
                    me.innerHTML = "Llenar establecimiento";
                }
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-window-restore",
          btnClass: "btn bg-gradient-yellow",
          btnClick: (data) => {
            this.handleAnotacionMarginalEstablecimiento(data);
          },
          render: (me, data) => {
            if (data.accion_id !== "3005") {
              me.remove();
            } else {
              if (
                data.estatus_tramite_id !== "3" 
              ) {
                me.remove();
              }
            }
          },
        },
        {
          iconClass: "fa fa-list",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            window.location.href =
              "/solicitud/inscripcion-establecimiento/" + data.dse_id;
          },
          render: (me, data) => {
            if (data.dse_id === null) {
              me.remove();
            }

            if (data.estatus_tramite_id !== "3" || data.accion_id === "3005") {
              me.remove();
            }
          },
        },
        {
          iconClass: "fa fa-paperclip",
          btnClass: "btn bg-gradient-blue",
          btnClick: (data) => {
            let post = "app/setEstablishmentDocs";
            let request =
              `app/getEstablishmentsDocs?establecimiento=${data.establecimiento_id}` +
              "&solicitud=" +
              data.solicitud_id +
              "&actividad=" +
              data.actividad_id +
              "&accion=" +
              data.accion_id +
              "&tipo_establecimiento=" +
              data.tipo_establecimiento_id;

            if (data.accion_id === "3005") {
              // Nota marginal
              request = `app/getAMEDocs?solicitud_id=${data.solicitud_id}`;
              post = "app/setAMEstablishmentDocs";
            }

            Api.loading(true);
            Api.fetch(request).then((files) => {
              let docs = [];
              let aprobados = [];
              if (data.estatus_tramite_id === "6") {
                for (let r in files["rechazados"]) {
                  let d = files["documentos"].find(
                    (d) => d.id === files["rechazados"][r].tipo_documento_id
                  );
                  d["descripcion"] =
                    d["descripcion"] +
                    " <b>[OBSERVACIÓN]:</b> <u>" +
                    files["rechazados"][r].observacion +
                    "</u>";
                  docs.push(d);
                }
              } else {
                docs = files["documentos"];
                aprobados = files["aprobados"];
              }

              Api.loading(false);

              uploadDocs = Api.upload({
                target: "#cargaDocs",
                required: docs,
                ok: aprobados,
                post: post,
                exts: ".jpg, .jpeg, .png, .pdf",
                params: data,
                onFinish: (r) => {
                  Swal.fire({
                    title: "Carga de documentos",
                    type: "success",
                    html: "Carga completa con éxito",
                    icon: "success",
                  });

                  modalarchivos.close();

                  mi_grid.go(0); // ir a la pagina actual - refrescar el grid
                },
              });

              let modalarchivos = Api.modal({
                title: "Documentación requerida",
                html: uploadDocs,
              });
            });
          },
          render: (me, data) => {
            //si esta en espera, checamos si los regentes invitados ya aceptaron la invitacion
            if (data.estatus_tramite_id !== null) {
              if (data.estatus_tramite_id === "1") {
                if (data.dse_id !== null) {
                  Api.fetch(
                    "app/checkRegentInvites",
                    { id: data.establecimiento, dse_id: data.dse_id },
                    "PUT"
                  ).then((data) => {
                    if (data) {
                      if (data.message === "Se actualizó de manera correcta") {
                        mi_grid.go(0);
                      }
                    }
                  });
                }
              }
            }
            if (
              data.estatus_tramite_id !== "7" &&
              data.estatus_tramite_id !== "6"
            ) {
              me.remove();
            }
          },
        },
      ],
    };

    mi_grid = Api.grid(grid);

    let uploadDocs = {};

    let busqueda = Api.form({
      target: "#busqueda",
      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "folio_solicitud",
            label: "Folio solicitud",
            placeHolder: "Folio solicitud",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            cols: 3,
            name: "tramite",
            label: "Trámite",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.TramiteCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            type: "text",
            name: "razon_social",
            label: "Razón Social",
            placeHolder: "Razón social",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            cols: 3,
            name: "tipo_establecimiento",
            label: "Tipo establecimiento",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.tipoEstablecimientoCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 3,
            name: "actividad",
            label: "Actividad",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.tipoActividadCombo.forEach((s) => {
                me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
              });
            },
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 2,
            value: "",
          },
        },
        {
          select: {
            cols: 3,
            name: "estado",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              let array_mostrar = [1,2,3,4,5,6,7,8,13,14];
                  this.state.estatusTramiteCombo.forEach(s=>{
                    if(array_mostrar.includes(parseInt(s.id))){
                      me.innerHTML+=`<option value="${s.id}">${s.descripcion}</option>`;
                    }
                  })
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarEstablecimientos: busqueda.data() });
              let search = this.state.buscarEstablecimientos;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }
              mi_grid.go(1, src);
            },
          },
        },
      ],
    });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item active">Establecimientos</li>
        </ol>
        <h1 className="page-header">Establecimientos</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
        <div className="hide">
          <fieldset id="cargaDocs"></fieldset>
        </div>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <Establecimientos auth={auth} history={history} {...props} />;
};
